import React from "react";
import {
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { StatusBar } from "expo-status-bar";

interface HelpSupportModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const HelpSupportModal: React.FC<HelpSupportModalProps> = ({
  isVisible,
  onClose,
}) => {
  const supportPoints: string[] = [
    "Username must be between 4 and 25 characters long.",
    "Username can only contain letters, numbers, dots, underscores, and hyphens.",
    "Password must be at least 8 characters in length.",
    "Password must contain at least one number. (e.g., !@#$%^&*).",
    "Password must contain at least one special character.",
    "Password must contain at least one uppercase character.",
    "Password must contain at least one lowercase character.",
  ];

  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={isVisible}
      onRequestClose={onClose}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <View style={styles.header}>
            <Text style={styles.modalTitle}>Help & Support</Text>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <Ionicons name="close" size={24} color="black" />
            </TouchableOpacity>
          </View>
          <ScrollView style={styles.content}>
            {supportPoints.map((point, index) => (
              <View key={index} style={styles.bulletPoint}>
                <Ionicons
                  name="checkmark-circle-outline"
                  size={24}
                  color="#007AFF"
                />
                <Text style={styles.bulletText}>{point}</Text>
              </View>
            ))}
            <Text style={styles.contactText}>
              For further assistance, please contact support at
              support@kaiapp.com
            </Text>
          </ScrollView>
        </View>
      </View>
      <StatusBar style="auto" />
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalView: {
    backgroundColor: "white",
    borderRadius: 20,
    padding: 20,
    width: "90%",
    maxHeight: "80%",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: "bold",
    alignSelf: "center",
  },
  closeButton: {
    padding: 5,
  },
  content: {
    marginBottom: 10,
  },
  bulletPoint: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 15,
  },
  bulletText: {
    fontSize: 16,
    marginLeft: 10,
    flex: 1,
  },
  contactText: {
    fontSize: 14,
    color: "#666",
    marginTop: 20,
    textAlign: "center",
  },
});

export default HelpSupportModal;
